import { render, staticRenderFns } from "./SFXEditLinkedData.vue?vue&type=template&id=0ea828a9&"
import script from "./SFXEditLinkedData.vue?vue&type=script&lang=js&"
export * from "./SFXEditLinkedData.vue?vue&type=script&lang=js&"
import style0 from "./SFXEditLinkedData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports